import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center space-x-3" }
const _hoisted_4 = { class: "p-6 space-y-6" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "ml-3" }
const _hoisted_7 = { class: "mt-2 text-sm text-red-700 dark:text-red-300" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" }
const _hoisted_9 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_10 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_11 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_12 = { class: "text-gray-900 dark:text-white font-mono text-sm break-all" }
const _hoisted_13 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_14 = { class: "text-gray-900 dark:text-white font-mono text-sm" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_18 = { class: "text-gray-900 dark:text-white font-mono text-sm" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_23 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_24 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_25 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_26 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_27 = { class: "flex items-center gap-2" }
const _hoisted_28 = {
  key: 0,
  class: "inline-block px-2.5 py-1 rounded text-xs font-semibold uppercase bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 border border-blue-300 dark:border-blue-700"
}
const _hoisted_29 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_30 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_31 = { class: "space-y-3" }
const _hoisted_32 = { class: "flex items-center gap-2" }
const _hoisted_33 = { class: "text-gray-900 dark:text-white" }
const _hoisted_34 = { class: "flex items-center gap-2" }
const _hoisted_35 = { class: "text-gray-900 dark:text-white" }
const _hoisted_36 = {
  key: 0,
  class: "flex items-start gap-2"
}
const _hoisted_37 = { class: "flex flex-wrap gap-2" }
const _hoisted_38 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_39 = { class: "font-semibold text-blue-500 min-w-[100px]" }
const _hoisted_40 = { class: "text-gray-600 dark:text-gray-300 flex-1" }
const _hoisted_41 = { class: "text-gray-500 dark:text-gray-400 font-mono text-sm" }
const _hoisted_42 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-400"
}
const _hoisted_43 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_44 = { class: "font-semibold text-blue-500 min-w-[150px]" }
const _hoisted_45 = { class: "text-gray-600 dark:text-gray-300 flex-1" }
const _hoisted_46 = { class: "text-gray-500 dark:text-gray-400 font-mono text-sm" }
const _hoisted_47 = {
  key: 1,
  class: "text-gray-500 dark:text-gray-400"
}
const _hoisted_48 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_49 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_50 = { class: "text-gray-900 dark:text-white" }
const _hoisted_51 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_52 = { class: "text-gray-900 dark:text-white" }
const _hoisted_53 = { class: "p-4 bg-gray-50 dark:bg-gray-700 rounded-lg" }
const _hoisted_54 = { class: "text-gray-900 dark:text-white" }

import { ref, reactive, computed, onMounted, onUnmounted, inject, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useTheme } from '../../utils/useTheme'
import TeamForm from './components/TeamForm.vue'
import DiffModal from './components/DiffModal.vue'
import { taskSentinelService } from '../../services/task-sentinel'
import type { Team, ToastType, ValidationDiffData } from '../../types/task-sentinel'
import { logger } from '../../utils/logger'

const DEFAULT_ROADMAP_BASE_URL = 'https://app.clickup.com/8631005/v/li'


export default /*@__PURE__*/_defineComponent({
  __name: 'details',
  setup(__props) {

const route = useRoute()
const theme = inject('theme', useTheme())

// State
const team = ref<Team | null>(null)
const editableTeam = ref<Team | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)
const isEditMode = ref(false)
const healthStatus = ref<'healthy' | 'unhealthy' | 'checking'>('checking')
const showDiffModal = ref(false)
const diffData = reactive<ValidationDiffData>({
  current: null,
  proposed: null
})

// Toast notification
const toast = reactive({
  show: false,
  message: '',
  type: 'info' as ToastType
})

// Health check interval
let healthCheckInterval: ReturnType<typeof setInterval> | null = null

// Computed
const sortedManagers = computed(() => {
  if (!team.value?.managers) return []
  return taskSentinelService.sortManagersByType(team.value.managers)
})

const parseRoadmapLinks = (value?: string) => {
  if (!value?.trim()) return []

  const tokens = value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)

  let baseUrl = DEFAULT_ROADMAP_BASE_URL
  const links: Array<{ id: string; href: string }> = []

  for (const token of tokens) {
    if (/^https?:\/\//i.test(token)) {
      try {
        const parsedUrl = new URL(token)
        const pathMatch = parsedUrl.pathname.match(/^(.*\/v\/li)\/([^/?#]+)/)

        if (pathMatch) {
          baseUrl = `${parsedUrl.origin}${pathMatch[1]}`
          const boardId = pathMatch[2]
          links.push({ id: boardId, href: `${baseUrl}/${boardId}` })
          continue
        }

        const fallbackId = parsedUrl.pathname.split('/').filter(Boolean).pop()
        if (fallbackId) {
          links.push({ id: fallbackId, href: token })
          continue
        }
      } catch {
        // Fall back to treating token as a board ID.
      }
    }

    const boardId = token.replace(/^\/+|\/+$/g, '')
    if (!boardId) continue
    links.push({ id: boardId, href: `${baseUrl}/${boardId}` })
  }

  return links
}

const roadmapLinks = computed(() => parseRoadmapLinks(team.value?.roadmapBoardId))

// Methods
const showToast = (message: string, type: ToastType = 'info') => {
  toast.message = message
  toast.type = type
  toast.show = true
  setTimeout(() => {
    toast.show = false
  }, 3000)
}

const loadTeam = async () => {
  const teamId = route.params.id as string
  if (!teamId) {
    error.value = 'No team ID provided'
    return
  }

  try {
    loading.value = true
    error.value = null

    const data = await taskSentinelService.fetchTeamById(teamId)
    team.value = data
    editableTeam.value = JSON.parse(JSON.stringify(data))

    logger.log('Team loaded:', { id: data.id, name: data.name })
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Failed to load team'
    logger.error('Error loading team:', err)
  } finally {
    loading.value = false
  }
}

const toggleEditMode = () => {
  if (isEditMode.value) {
    // Cancel edit - restore original data
    editableTeam.value = JSON.parse(JSON.stringify(team.value))
  }
  isEditMode.value = !isEditMode.value
}

const cancelEdit = () => {
  editableTeam.value = JSON.parse(JSON.stringify(team.value))
  isEditMode.value = false
}

const validateChanges = async () => {
  if (!editableTeam.value || !team.value) {
    showToast('No team data to validate', 'error')
    return
  }

  try {
    // Try API validation first
    const payload = buildPayload()
    const response = await taskSentinelService.validateTeam(team.value.id, payload)

    if (response?.data) {
      diffData.current = response.data.current
      diffData.proposed = response.data.proposed
      showDiffModal.value = true
    } else {
      // Fallback to local diff if API doesn't return expected format
      showLocalDiff()
    }
  } catch (err) {
    // If API fails, show local diff instead
    logger.warn('API validation failed, showing local diff:', err)
    showLocalDiff()
  }
}

const showLocalDiff = () => {
  if (!editableTeam.value || !team.value) return

  // Create clean copies for comparison
  const currentData = JSON.parse(JSON.stringify(team.value))
  const proposedData = JSON.parse(JSON.stringify(editableTeam.value))

  // Remove fields that shouldn't be compared
  delete currentData.dateAdded
  delete currentData.dateUpdated
  delete proposedData.dateAdded
  delete proposedData.dateUpdated

  diffData.current = currentData
  diffData.proposed = proposedData
  showDiffModal.value = true

  showToast('Showing local diff comparison', 'info')
}

const updateTeam = async () => {
  if (!editableTeam.value || !team.value) return

  try {
    const payload = buildPayload()
    await taskSentinelService.updateTeam(team.value.id, payload)

    showToast('Team updated successfully!', 'success')

    // Reload and exit edit mode
    await loadTeam()
    isEditMode.value = false
  } catch (err) {
    const message = err instanceof Error ? err.message : 'Update failed'
    showToast(message, 'error')
    logger.error('Update error:', err)
  }
}

const buildPayload = () => {
  if (!editableTeam.value) return {}

  return {
    name: editableTeam.value.name,
    standupId: editableTeam.value.standupId,
    roadmapBoardId: editableTeam.value.roadmapBoardId,
    parentGroup: editableTeam.value.parentGroup,
    type: editableTeam.value.type,
    deleted: editableTeam.value.deleted,
    isNew: editableTeam.value.isNew,
    sendToEmOnly: editableTeam.value.sendToEmOnly,
    managers: editableTeam.value.managers,
    devs: editableTeam.value.devs,
    ignoreDevs: editableTeam.value.ignoreDevs,
    meta: editableTeam.value.meta
  }
}

const lookupEmail = async (email: string, type: 'manager' | 'dev', index: number) => {
  try {
    const response = await taskSentinelService.lookupUserByEmail(email)
    if (response.success && response.data && editableTeam.value) {
      const emailPrefix = taskSentinelService.extractEmailPrefix(response.data.email)

      if (type === 'manager') {
        editableTeam.value.managers[index].emailPrefix = emailPrefix
        editableTeam.value.managers[index].slackId = response.data.slackId || ''
      } else {
        editableTeam.value.devs[index].emailPrefix = emailPrefix
        editableTeam.value.devs[index].slackId = response.data.slackId || ''
        editableTeam.value.devs[index].name = response.data.name || ''
      }

      showToast('User found and applied!', 'success')
    }
  } catch (err) {
    logger.error('Email lookup error:', err)
  }
}

const formatDate = (dateString: string | undefined): string => {
  return taskSentinelService.formatDate(dateString)
}

const checkHealth = async () => {
  healthStatus.value = 'checking'
  const isHealthy = await taskSentinelService.checkHealth()
  healthStatus.value = isHealthy ? 'healthy' : 'unhealthy'
}

// Lifecycle
onMounted(() => {
  loadTeam()
  checkHealth()
  healthCheckInterval = setInterval(checkHealth, 15000)
})

onUnmounted(() => {
  if (healthCheckInterval) {
    clearInterval(healthCheckInterval)
  }
})

// Watch for route changes
watch(
  () => route.params.id,
  () => {
    loadTeam()
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'fixed top-5 right-5 z-50 px-4 py-2 rounded-full text-xs font-semibold flex items-center gap-2 shadow-md border transition-all duration-200',
        healthStatus.value === 'healthy'
          ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 border-green-500'
          : healthStatus.value === 'unhealthy'
            ? 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 border-red-500'
            : 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 border-yellow-500'
      ])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass([
          'w-2 h-2 rounded-full',
          healthStatus.value === 'healthy'
            ? 'bg-green-500'
            : healthStatus.value === 'unhealthy'
              ? 'bg-red-500'
              : 'bg-yellow-500 animate-pulse'
        ])
      }, null, 2),
      _createElementVNode("span", null, _toDisplayString(healthStatus.value === 'healthy'
          ? 'Healthy'
          : healthStatus.value === 'unhealthy'
            ? 'Unhealthy'
            : 'Checking...'), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
        'border-b px-6 py-4'
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", {
            class: _normalizeClass([_unref(theme).isDark.value ? 'text-gray-100' : 'text-gray-900', 'text-2xl font-bold'])
          }, " Team: " + _toDisplayString(team.value?.name || 'Details'), 3)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass([
              'px-4 py-2 rounded-md font-semibold shadow-sm transition-all',
              isEditMode.value
                ? 'bg-gray-500 hover:bg-gray-600 text-white'
                : 'bg-green-500 hover:bg-green-600 text-white'
            ]),
            onClick: toggleEditMode
          }, _toDisplayString(isEditMode.value ? 'Cancel Edit' : 'Edit'), 3),
          _createVNode(_component_router_link, {
            to: "/task-sentinel",
            class: "px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md font-semibold shadow-sm transition-all"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" ← Back to Teams ")
            ])),
            _: 1,
            __: [2]
          })
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      (error.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-red-900 border-red-700' : 'bg-red-50 border-red-200',
          'border rounded-md p-4'
        ])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                _createElementVNode("svg", {
                  class: "h-5 w-5 text-red-400",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_6, [
                _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-sm font-medium text-red-800 dark:text-red-200" }, "Error", -1)),
                _createElementVNode("div", _hoisted_7, _toDisplayString(error.value), 1)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
          'border rounded-lg p-8'
        ])
          }, _cache[5] || (_cache[5] = [
            _createStaticVNode("<div class=\"flex items-center justify-center\" data-v-3874ef03><svg class=\"animate-spin h-8 w-8 text-blue-500\" fill=\"none\" viewBox=\"0 0 24 24\" data-v-3874ef03><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\" data-v-3874ef03></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z\" data-v-3874ef03></path></svg><span class=\"ml-3 text-lg text-gray-600 dark:text-gray-300\" data-v-3874ef03>Loading team details...</span></div>", 1)
          ]), 2))
        : (team.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!isEditMode.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
              'border rounded-lg p-6'
            ])
                    }, [
                      _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-lg font-bold text-blue-500 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700" }, " Basic Information ", -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Team Name ", -1)),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(team.value.name || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Team ID ", -1)),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(team.value.id || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Folder ID ", -1)),
                          _createElementVNode("div", _hoisted_14, [
                            (team.value.standupId)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: `https://app.clickup.com/8631005/v/f/${team.value.standupId}`,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "text-blue-600 dark:text-blue-400 hover:underline break-all"
                                }, _toDisplayString(team.value.standupId), 9, _hoisted_15))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Roadmap Board ID ", -1)),
                          _createElementVNode("div", _hoisted_18, [
                            (roadmapLinks.value.length > 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(roadmapLinks.value, (roadmapLink, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: `${roadmapLink.id}-${index}`
                                  }, [
                                    _createElementVNode("a", {
                                      href: roadmapLink.href,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      class: "text-blue-600 dark:text-blue-400 hover:underline break-all"
                                    }, _toDisplayString(roadmapLink.id), 9, _hoisted_19),
                                    (index < roadmapLinks.value.length - 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, ", "))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, "-"))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Parent Group ", -1)),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(team.value.parentGroup || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Type ", -1)),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(team.value.type || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Status ", -1)),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                      'inline-block px-2.5 py-1 rounded text-xs font-semibold uppercase border',
                      team.value.deleted
                        ? 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 border-red-300 dark:border-red-700'
                        : 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 border-green-300 dark:border-green-700'
                    ])
                            }, _toDisplayString(team.value.deleted ? 'Deleted' : 'Active'), 3),
                            (team.value.isNew)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, " New "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Send to EM Only ", -1)),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(team.value.sendToEmOnly ? 'Yes' : 'No'), 1)
                        ])
                      ])
                    ], 2),
                    (team.value.meta)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
              'border rounded-lg p-6'
            ])
                        }, [
                          _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "text-lg font-bold text-blue-500 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700" }, " Meta Information ", -1)),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-gray-600 dark:text-gray-400 font-medium" }, "Combined Folder:", -1)),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(team.value.meta.isCombinedFolder ? 'Yes' : 'No'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-gray-600 dark:text-gray-400 font-medium" }, "Skip Previous Quarter:", -1)),
                              _createElementVNode("span", _hoisted_35, _toDisplayString(team.value.meta.skipPreviousQuarter ? 'Yes' : 'No'), 1)
                            ]),
                            (team.value.meta.subModules && team.value.meta.subModules.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-gray-600 dark:text-gray-400 font-medium" }, "Sub Modules:", -1)),
                                  _createElementVNode("div", _hoisted_37, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.value.meta.subModules, (module) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: module,
                                        class: "px-3 py-1 bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-full text-sm font-medium border border-blue-300 dark:border-blue-700"
                                      }, _toDisplayString(module), 1))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
              'border rounded-lg p-6'
            ])
                    }, [
                      _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "text-lg font-bold text-blue-500 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700" }, " Managers ", -1)),
                      (sortedManagers.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedManagers.value, (manager) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `${manager.type}-${manager.emailPrefix}`,
                                class: "flex items-center gap-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                              }, [
                                _createElementVNode("span", _hoisted_39, _toDisplayString(manager.type), 1),
                                _createElementVNode("span", _hoisted_40, _toDisplayString(manager.emailPrefix), 1),
                                _createElementVNode("span", _hoisted_41, _toDisplayString(manager.slackId || '-'), 1)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_42, " No managers assigned "))
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
              'border rounded-lg p-6'
            ])
                    }, [
                      _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "text-lg font-bold text-blue-500 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700" }, " Developers ", -1)),
                      (team.value.devs && team.value.devs.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(team.value.devs, (dev) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: dev.emailPrefix,
                                class: "flex items-center gap-4 p-3 bg-gray-50 dark:bg-gray-700 rounded-lg"
                              }, [
                                _createElementVNode("span", _hoisted_44, _toDisplayString(dev.name || dev.emailPrefix), 1),
                                _createElementVNode("span", _hoisted_45, _toDisplayString(dev.emailPrefix), 1),
                                _createElementVNode("span", _hoisted_46, _toDisplayString(dev.slackId || '-'), 1)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_47, " No developers assigned "))
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
              'border rounded-lg p-6'
            ])
                    }, [
                      _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "text-lg font-bold text-blue-500 mb-4 pb-3 border-b border-gray-200 dark:border-gray-700" }, " Additional Information ", -1)),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Date Added ", -1)),
                          _createElementVNode("div", _hoisted_50, _toDisplayString(formatDate(team.value.dateAdded)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Date Updated ", -1)),
                          _createElementVNode("div", _hoisted_52, _toDisplayString(formatDate(team.value.dateUpdated)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-1" }, " Ignore Devs ", -1)),
                          _createElementVNode("div", _hoisted_54, _toDisplayString(team.value.ignoreDevs && team.value.ignoreDevs.length > 0
                      ? team.value.ignoreDevs.join(', ')
                      : 'None'), 1)
                        ])
                      ])
                    ], 2)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(TeamForm, {
                      team: editableTeam.value,
                      "onUpdate:team": _cache[0] || (_cache[0] = ($event: any) => ((editableTeam).value = $event)),
                      onLookupEmail: lookupEmail
                    }, null, 8, ["team"]),
                    _createElementVNode("div", {
                      class: _normalizeClass([
              _unref(theme).isDark.value ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200',
              'border rounded-lg p-6 flex gap-4'
            ])
                    }, [
                      _createElementVNode("button", {
                        class: "px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-md font-semibold shadow-sm transition-all",
                        onClick: validateChanges
                      }, " Validate Changes "),
                      _createElementVNode("button", {
                        class: "px-6 py-3 bg-green-500 hover:bg-green-600 text-white rounded-md font-semibold shadow-sm transition-all",
                        onClick: updateTeam
                      }, " Update Team "),
                      _createElementVNode("button", {
                        class: "px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white rounded-md font-semibold shadow-sm transition-all",
                        onClick: cancelEdit
                      }, " Cancel ")
                    ], 2)
                  ], 64))
            ], 64))
          : _createCommentVNode("", true)
    ]),
    (showDiffModal.value)
      ? (_openBlock(), _createBlock(DiffModal, {
          key: 0,
          "old-data": diffData.current,
          "new-data": diffData.proposed,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showDiffModal.value = false))
        }, null, 8, ["old-data", "new-data"]))
      : _createCommentVNode("", true),
    (toast.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
        'fixed top-20 right-5 z-50 px-5 py-3 rounded-lg shadow-lg border font-medium max-w-md flex items-center gap-3 animate-slide-in',
        toast.type === 'success'
          ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 border-green-500'
          : toast.type === 'error'
            ? 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 border-red-500'
            : 'bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 border-blue-500'
      ])
        }, _toDisplayString(toast.message), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})